module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/278.15cfd8a3.png";